import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { analyticsAPI } from "../../utils/analyticsAPI";
import MetricCard from "../../components/MetricCard";
import { FiUsers, FiFileText, FiClock } from "react-icons/fi";

function AnalystDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = useState({
    assigned_clients: 0,
    reports_created: 0,
    pending_reviews: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardStats();
  }, []);

  const loadDashboardStats = async () => {
    try {
      setLoading(true);
      const response = await analyticsAPI.getAnalystStats();
      const data = response?.data || response;
      setStats({
        assigned_clients: data.assigned_clients || 0,
        reports_created: data.reports_created || 0,
        pending_reviews: data.pending_reviews || 0,
      });
    } catch (error) {
      console.error("Failed to load dashboard stats:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="greeting-section" style={{ marginBottom: "32px" }}>
        <h1>Welcome back, {user?.first_name || user?.name || "Analyst"}!</h1>
        <p>
          Let's dive into your assigned clients and create some great reports.
        </p>
      </div>

      <div className="stats-grid">
        <MetricCard
          label="Assigned Clients"
          value={loading ? "..." : stats.assigned_clients}
          tone="primary"
          icon={<FiUsers />}
          onClick={() => navigate("/analyst/clients")}
        />
        <MetricCard
          label="Reports Created"
          value={loading ? "..." : stats.reports_created}
          tone="success"
          icon={<FiFileText />}
          onClick={() => navigate("/analyst/design-report")}
        />
        <MetricCard
          label="Pending Reviews"
          value={loading ? "..." : stats.pending_reviews}
          tone="warning"
          icon={<FiClock />}
          onClick={() => navigate("/analyst/analysis")}
        />
      </div>
      <div className="card">
        <h2 className="card-title">Analyst Dashboard</h2>
        <p style={{ color: "var(--text-grey)", lineHeight: "1.6" }}>
          Welcome to your analyst portal.
        </p>
      </div>
    </div>
  );
}
export default AnalystDashboard;
